export default {
  SET_SETTINGS(state, settings) {
    const previousDefaultAdminContactLineLink = state.defaultAdminContactLineLink
    const previousAdminContactLineLink = state.adminContactLineLink

    if (settings.lineAt) {
      state.lineAt = settings.lineAt
    }
    if (settings.linkLine) {
      state.linkLine = settings.linkLine
    }
    state.defaultAdminContactLineLink = settings.adminContactLineLink || settings.linkLine || state.linkLine
    state.adminContactLineLink = previousAdminContactLineLink && previousAdminContactLineLink !== previousDefaultAdminContactLineLink
      ? previousAdminContactLineLink
      : state.defaultAdminContactLineLink
    if (Array.isArray(settings.domains)) {
      state.domains = settings.domains
    }
    if (settings.partnerReferralHost) {
      state.partnerReferralHost = settings.partnerReferralHost
    }
    state.isLoaded = true
  },
  SET_SETTINGS_FALLBACK(state, settings) {
    if (settings.lineAt) {
      state.lineAt = settings.lineAt
    }
    if (settings.linkLine) {
      state.linkLine = settings.linkLine
    }
    state.defaultAdminContactLineLink = settings.adminContactLineLink || settings.linkLine || state.linkLine
    state.adminContactLineLink = state.defaultAdminContactLineLink
    state.isLoaded = false
  },
  SET_DOMAIN_ACCESS(state, domainAccess) {
    state.domains = Array.isArray(domainAccess.domains) ? domainAccess.domains : []
    state.partnerReferralHost = domainAccess.partnerReferralHost || ''
  },
  SET_LINE_AT(state, lineAt) {
    state.lineAt = lineAt
  },
  SET_LINK_LINE(state, linkLine) {
    state.linkLine = linkLine
  },
  SET_ADMIN_CONTACT_LINE_LINK(state, adminContactLineLink) {
    state.adminContactLineLink = adminContactLineLink || state.linkLine
  }
}
